module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAAGzCI4dAAAABGdBTUEAALGPC/xhBQAAAFRJREFUGBljYGBgkAViBnY4wQjlMYNE4AAsD+MxARko0iA9XED8F6pCDErDKXaQFhSALgA2D2QGLsAF0gGzAJuiv+hGYihiAYqAnPYWiNFNAtkvDAD6lQWbHboy4QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/8pxGuides.png
// module id = 245
// module chunks = 0